import React, { useState, CSSProperties, useEffect } from "react";
import logo from '../../../assets/images/logo.png'
import { API_BASE_URL } from "helpers/api/apiServices";
import { sendVisitLog } from "helpers/visitLogger";

const Cookies = require("js-cookie");

const CookiesDemo = () => {
    const [isCookieSet, setCookie] = useState<boolean>(!!Cookies.get("cookieConsent"));

    useEffect(() => {
        if (!isCookieSet) {
            const currentPage = window.location.href;
            Cookies.set("lastPageVisited", currentPage, { expires: 1 });
        }
    }, [isCookieSet]);



    const handleAcceptCookies = async () => {
        let country = "Unknown";
        try {
            const res = await fetch("https://geolocation-db.com/json/");
            const data = await res.json();

            if (data?.country_name) {
                country = data.country_name;
                localStorage.setItem("userCountry", country);
                Cookies.set("userCountry", country, { expires: 7 });
            }
        } catch (err) {
            console.log("Country fetch failed", err);
        }

        Cookies.set("cookieConsent", "true", { expires: 1 });
        Cookies.set("lastPageVisited", window.location.href, { expires: 1 });

        sendVisitLog(window.location.href);
        setCookie(true);
        window.location.reload();
    };



    const handleRejectCookies = () => {
        Cookies.set("cookieConsent", "false", { expires: 1 });
        sendVisitLog(window.location.href);
        setCookie(true); // close popup immediately
    };

    return (
        <>
            {!isCookieSet && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                        <view>
                            <img src={logo} alt="logo" height="30" className="align-self-center" />
                        </view>

                        <h2 style={styles.title}>Our website uses cookies</h2>


                        We and selected third parties use cookies or similar technologies for technical purposes and, with your consent, for other purposes as specified in the{" "}
                        <a href="/cookie-policy" style={styles.link}>cookie policy</a>.
                        <br />
                        Use the "Accept" button to consent. Use the "Reject" button to continue without accepting.


                        <div style={styles.actions}>
                            <button style={styles.acceptButton} onClick={handleAcceptCookies}>
                                Accept All
                            </button>
                            <button style={styles.rejectButton} onClick={handleRejectCookies}>
                                Reject All
                            </button>
                        </div>

                        <button style={styles.linkButton}>Cookie Preferences</button>
                    </div>
                </div>
            )}
        </>
    );
};

const styles: { [key: string]: CSSProperties } = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
    },
    modal: {
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "16px",
        maxWidth: "600px",
        width: "90%",
        boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
        textAlign: "left",
        animation: "fadeIn 0.3s ease-in-out",
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold",
        marginBottom: "15px",
        color: "#0d1b2a",
        marginTop: '15px'
    },
    text: {
        fontSize: "15px",
        lineHeight: "1.6",
        marginBottom: "20px",
        color: "#333",
    },
    actions: {
        display: "flex",
        gap: "15px",
        marginBottom: "15px",
        marginTop: "16px"
    },
    acceptButton: {
        backgroundColor: "#2e7d32",
        color: "white",
        border: "none",
        padding: "12px 24px",
        borderRadius: "30px",
        fontWeight: "bold",
        cursor: "pointer",
        flex: 1,
    },
    rejectButton: {
        backgroundColor: "white",
        color: "#333",
        border: "2px solid #ccc",
        padding: "12px 24px",
        borderRadius: "30px",
        fontWeight: "bold",
        cursor: "pointer",
        flex: 1,
    },
    linkButton: {
        background: "none",
        border: "none",
        color: "#888",
        textDecoration: "underline",
        cursor: "pointer",
        fontSize: "14px",
        alignSelf: "flex-start",
    },
};

export default CookiesDemo;
